const initialState = {
  uuid: null,
  offer: {},
  offerId: null,
  invalidOffer: false,
  userToken: null,
  purchase: {},
  offerPrice: null,
  isNossa: false,
  isInsideApp: false,
  oldOfferId: null,
  oldOfferPrice: null,
  paymentData: {},
  isPriceFromHidden: false,
  isAnnualPriceHidden: false,
};

export default function SessionReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SESSION':
      return {
        ...state,
        uuid: action.uuid,
      };
    case 'SET_SESSION_OFFER':
      return {
        ...state,
        offer: action.offer,
      };
    case 'SET_OFFER_ID':
      return {
        ...state,
        offerId: action.offerId,
      };
    case 'SET_OFFER_INVALID':
      return {
        ...state,
        invalidOffer: action.offerCondition,
      };
    case 'SET_USER_SESSION':
      return {
        ...state,
        userToken: action.userToken,
      };
    case 'SET_MODALITY':
      return {
        ...state,
        modality: action.modality,
      };
    case 'SAVE_PURCHASE':
      return {
        ...state,
        purchase: action.purchase,
      };
    case 'SAVE_PAYMENT_DATA':
      return {
        ...state,
        paymentData: action.paymentData,
      };
    case 'CLEAN_PAYMENT_DATA':
      return {
        ...state,
        paymentData: {},
      };
    case 'SET_PRICE':
      return {
        ...state,
        offerPrice: action.offerPrice,
      };
    case 'SET_IS_NOSSA':
      return {
        ...state,
        isNossa: action.isNossa,
      };
    case 'SET_IS_INSIDE_APP':
      return {
        ...state,
        isInsideApp: action.isInsideApp,
      };
    case 'SET_OLD_OFFER_ID':
      return {
        ...state,
        oldOfferId: action.offerId,
      };
    case 'SET_OLD_OFFER_PRICE':
      return {
        ...state,
        oldOfferPrice: action.price,
      };
    case 'SET_IS_PRICE_FROM_HIDDEN':
      return {
        ...state,
        isPriceFromHidden: action.isPriceFromHidden,
      };
    case 'SET_IS_ANNUAL_PRICE_HIDDEN':
      return {
        ...state,
        isAnnualPriceHidden: action.isAnnualPriceHidden,
      };
    default:
      return state;
  }
}
